import * as React from "react";
import { createIcon } from "@chakra-ui/react";

const Undo = createIcon({
  path: (
    <path
      d="M0 6.41593C0 6.09933 0.1303 5.77341 0.353671 5.54992L5.6122 0.363166C5.84488 0.139679 6.15202 0 6.44984 0C7.12927 0 7.57601 0.474909 7.57601 1.12675C7.57601 1.47129 7.4364 1.73202 7.23164 1.93689L5.05377 4.06001L3.49948 5.34506L5.64943 5.25194H11.2244C15.4405 5.25194 18 7.8686 18 11.6679C18 15.5044 15.4871 18 11.3268 18H9.03723C8.3485 18 7.85522 17.4785 7.85522 16.836C7.85522 16.2028 8.3485 15.6813 9.03723 15.6813H11.2151C14.0817 15.6813 15.7104 13.9586 15.7104 11.6027C15.7104 9.23745 14.0817 7.57062 11.2151 7.57062H5.64943L3.50879 7.4775L5.05377 8.76255L7.23164 10.8764C7.4364 11.0905 7.57601 11.342 7.57601 11.6958C7.57601 12.3383 7.12927 12.8132 6.44984 12.8132C6.15202 12.8132 5.84488 12.6829 5.6122 12.4501L0.353671 7.27263C0.1303 7.04915 0 6.72323 0 6.41593Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 18 18",
});

export { Undo };
